/* eslint-disable prettier/prettier */
import { UseTranslationOptions, useTranslation } from 'react-i18next';
import translations from '../../../locales/features/VehicleProjects/baselinesPage.de.json';
import {
	ProjectDetailsPageParams,
	createGenPagePath,
	encodeGenAndModelSeries,
} from '../../VehicleProjects/vehicleProjectPagePaths';
import { useCallback } from 'react';
import { NavigateFunction, useNavigate } from 'react-router-dom';

export const translationNamespace = 'features/VehicleProjects/baselinesPage';

type Translations = typeof translations;

export const useBaselineListPageTranslations = (
	options?: UseTranslationOptions<keyof Translations>,
) => {
	return useTranslation(translationNamespace, options);
};

export const createBaselineListPagePath = (
	fields: ProjectDetailsPageParams,
): string => {
	const genPath: string = createGenPagePath(fields);
	return `${genPath}/baselines`;
};

export type NavigateToBaselineListPage = () => void;

export const useNavigateToBaselineListPage = (
	params: ProjectDetailsPageParams,
): NavigateToBaselineListPage => {
	const navigate: NavigateFunction = useNavigate();

	return useCallback((): void => {
		const encodedParams: ProjectDetailsPageParams =
			encodeGenAndModelSeries(params);
		const path: string = createBaselineListPagePath(encodedParams);
		navigate(path);
	}, [params, navigate]);
};
